import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'charla-html-modal',
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './html-modal.component.html'
})
export class HtmlModalComponent {
  @Input() html = '';

  constructor(public activeModal: NgbActiveModal) {}


}